import React from 'react'

const PurchaseIframe = ({ url }: { url: string }) => {
  return (
    <div className="absolute left-0 top-0 flex h-full w-full flex-1 bg-010">
      <iframe src={url} className="h-full w-full" />
    </div>
  )
}

export default PurchaseIframe
